import { ref, computed } from 'vue';

export const collapsed = ref(true);
export const toggleCollapsed = () => {
  collapsed.value = !collapsed.value;
};

export const SIDEBAR_WIDTH = 240;
export const SIDEBAR_COLLAPSED_WIDTH = 80;
export const sidebarWidth = computed(
    () => (collapsed.value ? SIDEBAR_COLLAPSED_WIDTH : SIDEBAR_WIDTH)
);
